import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy } from '@angular/core';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { AppSettings } from '../../../app.settings';
import { Settings } from '../../../app.settings.model';
import { MenuService } from 'src/app/shared/services/menu.service';
import { IMenu } from 'src/app/shared/responses/imenu';
import { IUserProfile } from 'src/app/shared/responses/iuser-profile';
import { ProfileDbService } from 'src/app/shared/services/profile-db.service';
import * as debug from 'src/app/shared/services/debug.service';

@Component({
	selector: 'app-sidenav',
	templateUrl: './sidenav.component.html',
	styleUrls: ['./sidenav.component.scss'],
	encapsulation: ViewEncapsulation.None,
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class SidenavComponent {
	@Input() profilePic: string;
	@Input() menuItems: IMenu[];
	// @Input() isInProfilePicPage = false;

	psConfig: PerfectScrollbarConfigInterface = {
		wheelPropagation: true
	};
	settings: Settings;
	fullName: string;

	constructor(public appSettings: AppSettings, public menuService: MenuService
		, readonly profileDbService: ProfileDbService
	) {
		this.settings = this.appSettings.settings;

		if (!!this.menuService.userProfile.familyName) {

			this.fullName = `${this.menuService.userProfile.givenName} ${this.menuService.userProfile.familyName}`;

		} else {

			this.fullName = this.menuService.userProfile.givenName;

		}

		debug.log(`087 SidenavComponent instantiated menuItems:`, this.menuItems);
	}

	get activeModule(): IMenu {

		debug.log(`087 SidenavComponent: activeModule`, this.menuService.activeModule);

		return this.menuService.activeModule;

	}

	// get menuItems(): IMenu[] {
	//     debug.log(`===SidenavComponent menuItems menuParentId: ${this.menuService.activeModule.id}`);
	//     const menus = this.menuService.menus.filter(item => item.parentId === this.menuService.activeModule.id);

	//     return menus;
	// }

	DoCheck() {

		if (this.settings.fixedSidenav) {

			if (this.psConfig.wheelPropagation) {

				this.psConfig.wheelPropagation = false;

			}

		} else {

			if (this.psConfig.wheelPropagation === false) {

				this.psConfig.wheelPropagation = true;

			}
		}
	}

	closeSubMenus() {

		const menu = document.getElementById('vertical-menu');

		if (menu) {
			const rootMenu = menu.children[0];

			// tslint:disable-next-line: prefer-for-of
			for (let i = 0; i < rootMenu.children.length; i++) {

				const child = rootMenu.children[i];

				if (child) {
					if (child.children[0].classList.contains('expanded')) {
						child.children[0].classList.remove('expanded');
						child.children[1].classList.remove('show');
					}
				}
			}
		}
	}
}
